export default {
  primary: 'med-deep-navy',
  secondary: 'med-navy',
  // success: 'cvt-success-border',
  info: 'med-aqua',
  warning: 'med-orange',
  // error: 'cvt-error-border',
  neutral: 'neutral',
}
